<template>
	<div :class="{ 'has-logo': showLogo }">
		<logo v-if="showLogo" :collapse="isCollapse" />
		<el-scrollbar wrap-class="scrollbar-wrapper">
			<el-menu
				:key="sidebarKey"
				:default-active="activeMenu"
				:collapse="isCollapse"
				:background-color="variables.menuBg"
				:text-color="variables.menuText"
				:unique-opened="false"
				:active-text-color="variables.menuActiveText"
				:collapse-transition="false"
				mode="vertical"
			>
				<sidebar-item v-for="route in permission_prod_rules" :key="route.path" :item="route" :base-path="route.path" />

				<template v-if="customMenuItems.length > 0">
					<sidebar-item
						v-for="item in customMenuItems"
						:key="item.path"
						:item="item"
						:base-path="item.path"
					/>
				</template>
			</el-menu>
		</el-scrollbar>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import Logo from './Logo';
import SidebarItem from './SidebarItem';
import variables from '@/styles/variables.scss';
import { EventBus } from '@/eventBus';
import Logging from '@/logging';

export default {
	components: { SidebarItem, Logo },
	data() {
		return {
			sidebarKey: Math.floor(Math.random() * 1000)
		};
	},
	computed: {
		...mapGetters(['permission_routes', 'sidebar', 'env', 'beta', 'selectedParticipantStore', 'selectedLegalEntityStore']),
		permission_prod_rules() {
			Logging.log('permission_routes: ', this.permission_routes);
			if (this.env === 'production' && this.beta !== 'true') {
				return this.permission_routes.filter(route => !route.path.includes('templates'));
			} else {
				return this.permission_routes;
			}
		},
		activeMenu() {
			const route = this.$route;
			const { meta, path } = route;
			// if set path, the sidebar will highlight the path you set
			if (meta.activeMenu) {
				return meta.activeMenu;
			}
			return path;
		},
		showLogo() {
			return this.$store.state.settings.sidebarLogo;
		},
		variables() {
			return variables;
		},
		isCollapse() {
			return !this.sidebar.opened;
		},
		customMenuItems() {
			const participantRef = this.selectedParticipantStore;
			const legalEntityRef = this.selectedLegalEntityStore;

			if (!participantRef) return [];

			const uiDetails = this.$store.state.risolto.userInterfaceDetails;
			if (!uiDetails || !uiDetails[participantRef]) return [];

			const participantDetails = uiDetails[participantRef];
			if (!participantDetails.legal_entity || !participantDetails.legal_entity.custom_actions) {
				return [];
			}

			return participantDetails.legal_entity.custom_actions.map(action => {
				const currentLang = this.$i18n.locale || 'en';
				const title = action.label[currentLang] || action.label.en || 'Custom Action';

				const queryParams = `?participantRef=${participantRef}${legalEntityRef ? '&legalEntityRef=' + legalEntityRef : ''}`;
				const fullPath = action.endpoint + queryParams;

				return {
					path: fullPath,
					meta: {
						required_licence: action.required_licence,
						required_permission: action.required_permission
					},
					children: [
						{
							path: fullPath,
							meta: {
								title,
								icon: action.icon || 'link',
								noCache: true,
								roles: ['user', 'admin', 'risolto-operator', 'superadmin']
							}
						}
					]
				};
			});
		}
	},
	created() {
		EventBus.$on('rerenderSidebar', data => {
			this.sidebarKey = Math.floor(Math.random() * 1000);
		});
	}
};
</script>
